<template>
  <div>
    <template v-if="videos.length > 0">
      <v-layout wrap>
        <template v-for="video in videos">
          <v-flex xs12 sm4 md3 :key="video.id" class="pa-1">
            <v-card @click="$emit('onSelect', video)" style="cursor: pointer">
              <v-img :src="video.picture" :aspect-ratio="16 / 9"></v-img>
              <v-card-title class="pa-2">{{
                video.title ? video.title : video.description
              }}</v-card-title>
              <v-card-text class="text-xs-right pa-2">
                <span class="caption grey--text">{{ video.time }}</span>
              </v-card-text>
              <v-card-text class="pa-1">
                <v-btn color="primary" depressed block>{{ $t('Select') }}</v-btn>
              </v-card-text>
            </v-card>
          </v-flex>
        </template>
      </v-layout>
    </template>
    <template v-else>
      <div class="text-xs-center">{{ $t('No video') }}</div>
    </template>
  </div>
</template>

<script>
import api from '@/api'
export default {
  props: [],
  data() {
    return {
      videos: []
    }
  },
  mounted() {
    this.getVideo()
  },
  methods: {
    getVideo: function() {
      var vm = this
      return new Promise((resolve, reject) => {
        api.getVideo().then(response => {
          // console.log(response)
          if (response.data && response.data.length > 0) {
            response.data.map(val => {
              var video = val
              video.time = vm.hhmmss(val.length)
              vm.videos.push(video)
            })
          }
        })
      })
    },
    pad(num) {
      return ('0' + num).slice(-2)
    },
    hhmmss(secs) {
      var minutes = Math.floor(secs / 60)
      secs = secs % 60
      var hours = Math.floor(minutes / 60)
      minutes = minutes % 60
      return `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(secs)}`
      // return pad(hours)+":"+pad(minutes)+":"+pad(secs); for old browsers
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/Videos.vue